module.exports = __webpack_public_path__ + "media/img/pages/profile/axpo ger 15-9ed38ded448147f599af96db40b9c188.jpg";